import { gql } from 'apollo-angular';

export const CloneFunnelForAnonymousUserDocument = gql`
  mutation cloneFunnelForAnonymousUser($funnelId: Int!) {
    cloneFunnelForAnonymousUser(funnelId: $funnelId) {
      id
    }
  }
`;
